import { useState } from 'react';
import { SliderProps } from 'types';
import { Slide } from './Slide';

import cx from 'classnames';
import styles from './Slider.module.scss';

export const Slider = ({ customClass, slides, coverColor}: SliderProps) => {
  const [active, setActive] = useState(0);
  const [previousChosen, setPreviousChosen] = useState(0);

  return (
    <div className={cx(styles.container, customClass)}>
      {coverColor && <div className={styles.cover} style={{ backgroundColor: coverColor }} />}
      {!!slides.length &&
        slides.map((slide, index) => (
          <Slide
            key={index}
            index={index}
            active={active}
            previousChosen={previousChosen}
            setActive={setActive}
            setPreviousChosen={setPreviousChosen}
            slides={slides}
            image={slide.image}
            title={slide.title}
            description={slide.subtitle}
          />
        ))}
    </div>
  );
};
